import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import Search from "../../../../components/DstIcons/Search";
import Lister from "../../../../components/Lister/Lister";
import Popup from "../../../../components/Popup/Popup";
import { formatDateHumanly } from "../../../../services/TimeService";
import translate from "../../../../services/Translate";
import { fetchUserEmails, openEmail } from "./UserEmails.function";

const UserEmails = ({
  userId,
  userEmail,
  language,
}: {
  userId: number;
  userEmail: string;
  language: string;
}): JSX.Element => {
  const [emails, setEmails] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailModalContent, setEmailModalContent] = useState("");
  const ref = React.useRef<any>();
  const [height, setHeight] = React.useState("0px");

  useEffect(() => {
    fetchUserEmails(userId, setEmails, setLoading);
  }, [userId]);
  const _onLoad = () => {
    setHeight(`${ref.current.contentWindow.document.body.scrollHeight + 20}px`);
  };

  return !loading ? (
    <div className="w-100">
      <Lister
        items={emails.map((user_email: any) => ({
          ...user_email,
          recipients: user_email.recipients.filter((recipient: string) => recipient !== userEmail).join(", "),
          date: user_email.date * 1000,
          status: user_email.is_read ? "read" : "not read",
        }))}
        columns={[
          { header: translate(language, "PAGES.USER.EMAIL_TABLE.RECIPIENT"), key: "recipients" },
          { header: translate(language, "PAGES.USER.EMAIL_TABLE.SUBJECT"), key: "subject" },
          {
            header: translate(language, "PAGES.USER.EMAIL_TABLE.DATE"),
            key: "date",
            render: (item: any) => (
              <div>
                <OverlayTrigger overlay={<Tooltip>{formatDateHumanly(language, item["date"], true)}</Tooltip>}>
                  <span>{formatDateHumanly(language, item["date"])}</span>
                </OverlayTrigger>
              </div>
            ),
          },
          { header: translate(language, "PAGES.USER.EMAIL_TABLE.ATTACHMENT"), key: "attachment" },
          {
            header: translate(language, "PAGES.USER.EMAIL_TABLE.STATUS"),
            key: "status",
            render: (item: any) => (
              <span className={`p-1 rounded ${item.status === "read" ? "status-green" : "status-red"}`}>
                {translate(language, `PAGES.USER.EMAIL_TABLE.${item.status === "read" ? "" : "NOT_"}READ`)}
              </span>
            ),
          },
        ]}
        additionalButton={(item: any) => (
          <span className="clickable" onClick={() => openEmail(item, setShowEmailModal, setEmailModalContent)}>
            <Search classes="search-icon" />
          </span>
        )}
      />
      <Popup
        show={showEmailModal}
        onClose={() => setShowEmailModal(false)}
        modalTitle="Email content"
        size="xl"
        fullscreen="lg-down"
        scrollable={true}
      >
        <iframe
          id="email-shower"
          title="email-shower"
          ref={ref}
          onLoad={_onLoad}
          srcDoc={emailModalContent}
          width="100%"
          height={height}
          style={{
            width: "100%",
            overflow: "auto",
          }}
        ></iframe>
      </Popup>
    </div>
  ) : (
    <Lister
      columns={[
        { header: translate(language, "PAGES.USER.EMAIL_TABLE.RECIPIENT"), key: "recipients" },
        { header: translate(language, "PAGES.USER.EMAIL_TABLE.SUBJECT"), key: "subject" },
        { header: translate(language, "PAGES.USER.EMAIL_TABLE.DATE"), key: "date" },
        { header: translate(language, "PAGES.USER.EMAIL_TABLE.ATTACHMENT"), key: "attachment" },
        { header: translate(language, "PAGES.USER.EMAIL_TABLE.STATUS"), key: "status" },
      ]}
      mock
    />
  );
};

export default UserEmails;
